import { atom, useAtomValue } from 'jotai'
import { useEffect } from 'react'
import { callListAtom } from '~/atoms/WebphoneState'
import { sendPopupSettings } from '~/hooks/useElectronIPC'
import { isElectron } from '~/utils/common'
import { LEAN_POPUP_STORAGE_KEY } from '~/utils/leanPopup'

import { FeatureFlag } from '@mangovoice/constants'
import { useFeatureFlag } from '@mangovoice/core'

const isCallActiveAtom = atom((get) => get(callListAtom).size > 0)

/**
 * Caches the lean-popup flag for the next `popup-settings` payload, which
 * Electron uses to pick the popup entry. Resends the payload whenever the
 * flag changes or the main window goes idle, but never while a call is
 * active, so Electron replaces a popup on the old entry. The resend on idle
 * is intended: other senders can send the cached value during a call, and
 * Electron ignores a payload whose entry already matches.
 */
export const useLeanPopupFlagSync = () => {
  const { isReady, isEnabled } = useFeatureFlag(FeatureFlag.DesktopLeanPopup)
  const isCallActive = useAtomValue(isCallActiveAtom)

  useEffect(() => {
    if (!isElectron || !isReady) {
      return
    }
    try {
      window.localStorage.setItem(LEAN_POPUP_STORAGE_KEY, String(isEnabled))
    } catch {
      // Storage unavailable: the popup keeps its last saved mode.
    }
  }, [isReady, isEnabled])

  useEffect(() => {
    if (isElectron && isReady && !isCallActive) {
      sendPopupSettings()
    }
  }, [isReady, isEnabled, isCallActive])
}
